import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  ShiftTiming,
  ShiftTimingResponse,
  ShiftTimingSingleResponse
} from 'Interfaces/ReferenceInterfaces/ShiftTimingsInterfaces';

export const shiftTimingScreenServices = {
  getAllShiftTimings: (page = 1, pageSize = 10000): Promise<ShiftTimingResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<ShiftTimingResponse>(
          `pps/shift-schedules?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getShiftTimingById: (id: number): Promise<ShiftTimingSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<ShiftTimingSingleResponse>(`pps/shift-schedules/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createShiftTiming: (
    shiftTimingData: Partial<ShiftTiming>
  ): Promise<ShiftTimingSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ShiftTimingSingleResponse>(
          'pps/shift-schedules/',
          shiftTimingData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateShiftTiming: (
    id: number,
    shiftTimingData: Partial<ShiftTiming>
  ): Promise<ShiftTimingSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<ShiftTimingSingleResponse>(
          `pps/shift-schedules/${id}/`,
          shiftTimingData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteShiftTiming: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/shift-schedules/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
